<template>
  <div class="client-promotional default-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12" style="text-align: center">
                  <h3>Acesso Promocional ao Conteúdo do Site</h3>
                  <span>Faça aqui o cadastro para receber gratuitamente nosso Boletim de Notícias semanal e ter acesso às Revistas On-line por um período promocional.</span>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>
                      Nome
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="client.name" class="form-control" />
                  </div>
                </div>
                <div class="col-12">
                  <address-form-component :address="client.address"></address-form-component>
                </div>
                <div class="col-12">
                  <contact-form-component :contact="client.contact"></contact-form-component>
                </div>
                <div class="col-12">
                  <div class="title-section">Dados de login</div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label for>
                      Login
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="user.login" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label for>
                      Senha
                      <span class="required-field">*</span>
                    </label>
                    <input type="password" v-model="user.password" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label for>
                      Confirmar senha
                      <span class="required-field">*</span>
                    </label>
                    <input type="password" v-model="user.confirm_password" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary float-right" v-on:click="save()">Criar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AddressFormComponent from "@/components/forms/AddressFormComponent";
import ContactFormComponent from "@/components/forms/ContactFormComponent";
import promotional_validate from "@/imports/validator/models/promotional_client";
import address_validate from "@/imports/validator/models/address";
import contact_validate from "@/imports/validator/models/contact";
import user_validate from "@/imports/validator/models/cliente_user";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "client-promotional",
  components: {
    AddressFormComponent,
    ContactFormComponent
  },
  data() {
    return {
      client: {
        address: {},
        contact: {}
      },
      user: {},
      createParams: {
        gender: ["Masculino", "Feminino"]
      }
    };
  },
  methods: {
    save: function() {
      let errors = validator.validate(this.client, promotional_validate.model);
      errors = errors.concat(
        validator.validate(this.client.address, address_validate.model)
      );
      errors = errors.concat(
        validator.validate(this.client.contact, contact_validate.model)
      );
      errors = errors.concat(
        validator.validate(this.user, user_validate.model)
      );

      if (errors.length == 0) {
        bus.$emit("changeLoading", true);
        if (this.client.contact.mail_marketing == "true") {
          this.client.contact.mail_marketing = true;
        }
        if (this.client.contact.mail_marketing == "false") {
          this.client.contact.mail_marketing = false;
        }
        this.client.user = this.user;

        let promise = axios.post(
          `${process.env.VUE_APP_API_HOST}/api/create_promotional_client`,
          this.client
        );

        promise
          .then(response => {
            bus.$emit("changeLoading", false);
            if (response.data.error) {
              Swal.fire({
                title: "Parece que esse login já esta em uso.",
                icon: "info"
              });
            } else {
              Swal.fire({
                title: "Obrigado por se registrar no Governet.",
                icon: "success",
                onClose: () => {
                  this.$router.push({ name: "client.login" });
                }
              });
            }
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.client-promotional {
  .title-section {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 8px;
  }
}
</style>